import ContractProfileEntities from './ContractProfileEntities';

export default ContractProfileEntities;
